export default "__VITE_ASSET__MV8K5fN7__"